import React, { useState } from "react";
import styled from "styled-components";
import { Table } from "antd";
import Axios from "axios";
import {
  SelectForm,
  MainBlock,
  MiniBlock,
  MiniBlockOrderRows,
  MiniBlockOrderRowsCustom,
} from "../../../common/Buttons";
import PreviewComment from "./editModal/previewComment";
import { connect } from "react-redux";
import SubmitComment from "./editModal/submitComment";
import { editPayment } from "../../../../redux/Actions/paymentAction";
import {
  createOrderStatus,
  getOrder,
  updateSerialNumber,
  updateSerialNumberState,
  clearErrors,
  postToRivile,
  postOrderShipping,
  updateOrderAddress,
  postOrderRow,
} from "../../../../redux/Actions/orderAction";
import {
  setCountriesOptions,
  setParcelTerminalsOptions,
} from "../../../../redux/Actions/options_action";
import {
  addContract,
  updateContract,
  deleteContractItem,
  deleteContract,
  sendContractEmail,
  firstAddContract,
  firstDeleteContract,
  changeContractItems,
} from "../../../../redux/Actions/orderContractAction";
import { getDocumentType } from "../../../../redux/Actions/documentTypeAction";
import AdditionalServicesMain from "./editModal/AdditionalServices/AdditionalSerivcesMain";
import AttachOrderDocument from "./editModal/AttachOrderDocument/AttachOrderDocument";
import { SerialNumberBlock } from "../../../common/SerialNumberModal";
import Spinner from "../../../common/Spinner";
import { GrEdit, GrClose } from "react-icons/gr";
import ShippingAddressComponent from "./editModal/shippingAddress";
import BillingAddressComponent from "./editModal/billingAddress";
import OrderRowsComponent from "./editModal/order_row/order_rows";
import PaymentBlockComponent from "./editModal/Payments/payments_block";
import OrderTotalComponent from "./editModal/SmallComp/order_total";
import SmsSending from "./editModal/SmallComp/sms_sending";
import { antdMessageError, phonenumberValid } from "../../../../helpers/Utils";
import DeliveryComponent from "./delivery/delivery_block";
import SupplyComponent from "./editModal/SupplyComponent";
import StatusComponent from "./StatusComponent";
import LeasingComponent from "./LeasingComponent";
import ShippingComponent from "./ShippingComponent";
import {
  onChangeCheckBoxDeliveryGlobal,
  handleChangeOrdertypeGlobal,
  shipment_type_setter,
  shipmentAdditionalServicesAttributesParams,
  setCod,
  availableCountries,
  setCodAmount2,
  orderRowBuildWithParents,
  possibilityToAssignDeliveryAmount,
  onlyFiOrders,
} from "../../../../helpers/OrdersFunctionsGlobal";
import { shipment_types_options } from "../../../../helpers/GlobalOptions";
import { AiOutlineAlert, AiOutlineInfoCircle } from "react-icons/ai";
import { ClassicButtonOutline } from "../../ButtonWithLoading";
import { Bubble } from "../../../common/StyledComponents";
import ActionHistoryContent from "../../../orders/accepted_orders/features/action_history/ActionHistoryContent";
import AntdConfirm from "../../../../helpers/AntdConfirm";
import OrderRowProductSuppliers from "../../../orders/accepted_orders/features/OrderRowProductSuppliers";
import { OrderTaxFree } from "./";
import { OrderActivities, OrderDiscounts } from "./editModal";
import { setOrderInitialValue } from "../../../../utils/order";
import OrderRowsReturn from "./editModal/order_row/OrderRowsReturn";

class OrderShowModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      order_type: "dpd",
      delivery: "dpd_b2c",

      suppliers: undefined,
      weight: 1,
      pack: 1,
      carrying: false,
      order_return: false,
      sendingDocuments: false,
      deliveryTime: false,
      deliveryOnSaturday: false,
      delivery_same_day: false,
      cod: false,
      cod_amount: 0,
      who: "",
      deliveryTimeHours: ["", ""],
      shipping_loading: false,
      // suppliersItems: [],
      swap: false,
      lp_express_sizes: undefined,
      delivery_after_18: false,
      ignore_stock_check: false,

      shipping_address_edit: {},

      terminalSelected: undefined,
      // Collapse
      tableItemsCollapses: Array.isArray(
        JSON.parse(localStorage.getItem("itemsCollapse"))
      )
        ? JSON.parse(localStorage.getItem("itemsCollapse")).filter(
          (d) => !d.includes("_add")
        )
        : ["order_information"],
      //
      payments_col: false,
      payments_add_col: false,
      delivery_add_col: false,
      tax_free_col: false,

      // Uzsakymo info redagavimas
      billingAdr_action_edit: false,
      shippingAdr_action_edit: false,

      skip_labels: false,
      selectedCarrier: "sendDirectly",
      savedShippingAddress: null,

      orderHistoryTableData: [],
      orderHistoryTableLoading: false,
      orderHistoryCustomerId: null,
    };
  }

  componentDidMount() {
    this.props.clearErrors();
    this.startedPack(this.props.order);
    this.props.setCountriesOptions();
    this.props.setParcelTerminalsOptions();

    if (this.collapseBlockActive("order_history_table")) {
      this.fetchCustomerOrders();
    }
  }

  getCustomerId = () => {
    return this.props.order?.customer_id || this.props.order?.customer?.id;
  };

  shouldLoadCustomerOrders = () => {
    const customerId = this.getCustomerId();
    return !!customerId && this.state.orderHistoryCustomerId !== customerId;
  };

  formatOrderHistoryDate = (date) => {
    if (!date) return "-";
    return date.toString().slice(0, 10);
  };

  formatOrderHistoryAmount = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return `${value} EUR`;
  };

  formatOrderHistoryGoods = (goods) => {
    if (!goods) {
      return "-";
    }

    const goodsArray = Array.isArray(goods) ? goods : [goods];

    const rows = goodsArray
      .map((row) => {
        const title = row?.product_name || row?.title || row?.name || "";
        const quantity = row?.quantity ?? row?.quanity ?? row?.qty;

        if (!title && (quantity === null || quantity === undefined || quantity === "")) {
          return null;
        }

        const safeTitle = title || "-";
        const safeQuantity = quantity ?? "-";

        return `${safeTitle} * ${safeQuantity}`;
      })
      .filter(Boolean);

    return rows.length > 0 ? rows.join("\n") : "-";
  };

  fetchCustomerOrders = () => {
    const customerId = this.getCustomerId();
    if (!customerId || this.state.orderHistoryTableLoading) {
      return;
    }

    this.setState({ orderHistoryTableLoading: true });

    Axios.get(`/api/v1/customers/${customerId}/orders`)
      .then((res) => {
        const orders = Array.isArray(res.data?.data) ? res.data.data : [];
        const mappedData = orders.map((orderItem, index) => ({
          id: orderItem.id,
          key: orderItem.id || `${customerId}-${index}`,
          order_no: orderItem.id_order || orderItem.id || "-",
          date: this.formatOrderHistoryDate(
            orderItem.order_date || orderItem.created_at
          ),
          goods: this.formatOrderHistoryGoods(
            orderItem.order_rows || orderItem.goods
          ),
          status:
            orderItem.status?.title ||
            "-",
          sum: this.formatOrderHistoryAmount(
            orderItem.total_price || orderItem.total_paid_tax_incl
          ),
        }));

        this.setState({
          orderHistoryTableData: mappedData,
          orderHistoryTableLoading: false,
          orderHistoryCustomerId: customerId,
        });
      })
      .catch(() => {
        this.setState({
          orderHistoryTableData: [],
          orderHistoryTableLoading: false,
          orderHistoryCustomerId: customerId,
        });
      });
  };

  openOrderFromHistory = (orderId) => {
    if (!orderId) return;
    this.props.getOrder(orderId);
  };

  startedPack = (orderInfo) => {
    // Check carrying
    this.props.getDocumentType(orderInfo.order_shop_id);
    this.setState({
      ...setOrderInitialValue(orderInfo, {
        pickup_addresses: this.props.pickup_addresses,
        order_rows: this.props.order_rows,
      }),
    });
  };

  onChangeCarrier = (carrier) => {
    const { ordersShipmentsOver80Kg } = this.props;

    if (carrier === "sendDirectly") {
      this.setState({
        selectedCarrier: carrier,
        shipping_address_edit:
          this.state.savedShippingAddress || this.state.shipping_address_edit,
      });
    } else {
      this.setState({
        selectedCarrier: carrier,
        savedShippingAddress: this.state.shipping_address_edit,
        shipping_address_edit: {
          ...ordersShipmentsOver80Kg?.[carrier],
          firstname: ordersShipmentsOver80Kg?.[carrier]?.name,
          lastname: "",
          country_id: ordersShipmentsOver80Kg?.[carrier]?.country_id,
          street: ordersShipmentsOver80Kg?.[carrier]?.address,
        },
      });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.order.cod !== this.props.order.cod ||
      prevProps.order.leasing_cod !== this.props.order.leasing_cod ||
      prevState.order_type !== this.state.order_type
    ) {
      this.setState({
        cod: setCod({
          cod: this.props.order.cod,
          leasing_cod: this.props.order.leasing_cod,
          shipment_type: this.state.order_type,
          payment_module: this.props.order.payment_module,
        }),
      });
    }

    if (
      prevState.cod !== this.state.cod ||
      prevProps.order_rows !== this.props.order_rows ||
      prevProps.or_quantity_manual !== this.props.or_quantity_manual ||
      prevProps.order.order_cart_rules !== this.props.order.order_cart_rules
    ) {
      const cod_amount = setCodAmount2({
        waiting_payments: this.props.order.waiting_payments,
        order_rows: this.props.order_rows,
        or_quantity_manual: this.props.or_quantity_manual,
        shipments: this.props.shipments,
        orderInfo: this.props.order,
        order_cart_rules: this.props.order.order_cart_rules,
      });
      this.setState({
        weight: this.countWeight(this.props.order_rows),
        cod_amount: cod_amount.price,
      });
    }

    if (prevProps.order?.customer_id !== this.props.order?.customer_id) {
      this.setState({
        orderHistoryTableData: [],
        orderHistoryTableLoading: false,
        orderHistoryCustomerId: null,
      });

      if (
        this.collapseBlockActive("order_history_table") &&
        this.shouldLoadCustomerOrders()
      ) {
        this.fetchCustomerOrders();
      }
    }
  }

  createShipping = () => {
    if (
      this.props.order.order_shop?.identifier == "TCH" &&
      this.state.order_type == "at_the_store" &&
      this.props.order_rows.filter((e) => e.selected).length == 0
    ) {
      return antdMessageError(
        "[TCH] Cannot be created without a product selected"
      );
    }
    this.setState({
      shipping_loading: true,
    });
    let orderVariables = {
      id_order: this.props.order.id_order,
      final_carrier: this.state.savedShippingAddress,
      shipment: {
        shipment_type: shipment_type_setter(
          this.state.order_type,
          this.state.delivery
        ),
        packets: this.state.pack,
        weight: this.state.weight,
        pickup_address_id: this.state.suppliers,
        skip_labels: this.state.skip_labels,
        ignore_stock_check: this.state.ignore_stock_check,
        shipment_address_attributes: {
          company: this.state.shipping_address_edit.company,
          name:
            this.state.shipping_address_edit.firstname +
            " " +
            this.state.shipping_address_edit.lastname,
          country_id: this.state.shipping_address_edit.country_id,
          address: this.state.shipping_address_edit.street,
          city: this.state.shipping_address_edit.city,
          postal_code: this.state.shipping_address_edit.postal_code,
          parcel_terminal_id: this.state.terminalSelected,
          phone: this.state.shipping_address_edit.phone?.trim(),
          email: this.state.shipping_address_edit.other,
          comment: this.state.shipping_address_edit.comment,
        },
        shipment_order_rows_attributes: this.props.order_rows
          .filter((e) => e.selected)
          .map((e) => ({
            quantity: this.props.or_quantity_manual[e.id] || +e?.quantity,
            title: e.product_name,
            price: e.unit_price_tax_incl,
            order_row_id: e.id,
          })),
        shipment_additional_services_attributes:
          shipmentAdditionalServicesAttributesParams({
            ...this.state,
            packets: this.state.pack,
            type: this.state.order_type,
            shipping_price: possibilityToAssignDeliveryAmount({
              shipments: this.props.shipments,
              orderInfo: this.props.order,
            }),
            cod_rules: setCodAmount2({
              waiting_payments: this.props.order.waiting_payments,
              order_rows: this.props.order_rows,
              or_quantity_manual: this.props.or_quantity_manual,
              shipments: this.props.shipments,
              orderInfo: this.props.order,
              order_cart_rules: this.props.order.order_cart_rules,
            }),
          }),
      },
    };
    const country_id =
      orderVariables.shipment.shipment_address_attributes?.country_id;
    if (!country_id) {
      return antdMessageError("Select the country");
    }
    const proceedWithShipping = () => {
      if (
        availableCountries(country_id, this.props.order.order_shop.country_id)
      ) {
        return this.createShippingApi(orderVariables);
      }
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to ship to this country:{" "}
            <b>{this.state.shipping_address_edit?.country?.en_name}</b>?
          </span>
        ),
        onOk: () => this.createShippingApi(orderVariables),
        onCancel: () =>
          this.setState({
            shipping_loading: false,
          }),
      });
    };

    if (this.state.order_type === "zipasgo" && this.state.suppliers) {
      const supplierInfo = this.props.pickup_addresses.find(
        (pa) => pa.id === this.state.suppliers
      );
      AntdConfirm({
        title: (
          <span>
            Are you sure you want to create a shipment with <b>ZipasGo</b> courier from supplier{" "}
            <b>{supplierInfo?.label || this.state.suppliers}</b>?
          </span>
        ),
        onOk: () => proceedWithShipping(),
        onCancel: () =>
          this.setState({
            shipping_loading: false,
          }),
      });
      return;
    }

    proceedWithShipping();
  };

  createShippingApi = async (orderVariables) => {
    try {
      const res = await this.props.postOrderShipping(
        this.state.id,
        orderVariables,
        "Order"
      );
      if (res.success) {
        this.props.clearErrors();
      }
    } catch (err) {
      console.log("createShippingApi: ", err);
    } finally {
      this.setState({
        shipping_loading: false,
      });
    }
  };

  handleChangeText = (e, where) => {
    if (where == null) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    } else {
      this.setState({
        [where]: {
          ...this.state[where],
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  countWeight = (items) => {
    const reducer = (accumulator, currentValue) => {
      if (
        typeof currentValue.product_info === "object" &&
        currentValue.product_info !== null
      ) {
        return accumulator + +currentValue.product_info.weight;
      } else {
        return accumulator + 0;
      }
    };

    return items.reduce(reducer, 0) || 1;
  };

  handleChangecollapseBlock = (item) => {
    const currentIndex = this.state.tableItemsCollapses.indexOf(item);
    const newChecked = [...this.state.tableItemsCollapses];
    if (currentIndex === -1) {
      newChecked.push(item);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      tableItemsCollapses: newChecked,
    });
    localStorage.setItem("itemsCollapse", JSON.stringify(newChecked));
  };

  collapseBlockActive = (name) => this.state.tableItemsCollapses.includes(name);

  updateOrderAddress = (action, dataObj) => {
    let params = {};
    delete dataObj.valid_phone;
    let objData = {
      ...dataObj,
      firstname: dataObj.firstname,
      lastname: dataObj.lastname,
      street: dataObj.street,
      city: dataObj.city,
      postal_code: dataObj.postal_code,
      phone: dataObj.phone,
      other: dataObj.other,
      country_id: dataObj.country_id,
      customer_id: dataObj.customer_id,
    };
    if (action == "billing") {
      params = {
        billing_address_attributes: {
          ...objData,
          company: dataObj.company,
          vat_code: dataObj.vat_code,
          company_code: dataObj.company_code,
        },
      };
      delete params.billing_address_attributes.country;
    } else if (action == "shipping") {
      params = {
        shipping_address_attributes: {
          ...objData,
        },
      };
      delete params.shipping_address_attributes.country;
    }

    this.props.updateOrderAddress(this.state.id, params).then((response) => {
      if (response.ok) {
        let changes = {};
        if (action == "billing") {
          changes = {
            billingAdr_action_edit: false,
          };
        } else if (action == "shipping") {
          changes = {
            shippingAdr_action_edit: false,
            shipping_address_edit: {
              ...this.state.shipping_address_edit,
              ...response.data.shipping_address,
            },
          };
        }
        this.setState({
          ...changes,
        });
      }
    });
  };

  paymentBlock = () => {
    this.props.editPayment({
      reference: "",
      payment_type: undefined,
      price: "",
    });
    this.handleChangecollapseBlock("payments_add_col");
  };

  updateShippingAddressTerminal = (shipping_address_edit) => {
    this.startedPack({
      ...this.props.order,
      shipping_address_edit,
    });
  };

  setSkipLabels = (value) => {
    this.setState({ skip_labels: value });
  };

  render() {
    const {
      documentType,
      order_histories,
      contracts,
      order_rows,
      shipments,
      order_documents,
      loading_order,
      order,
    } = this.props;

    const order_cart_rules = this.props.order.order_cart_rules;
    const order_type = this.state.order_type;
    const { billingAdr_action_edit, shippingAdr_action_edit } = this.state;
    if (loading_order) {
      return (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      );
    }
    const order_rows_rebuild = orderRowBuildWithParents(order_rows);
    const disabled = onlyFiOrders(this.props.auth.user.id);

    return (
      <div className="row">
        <div className="col-6">
          <Divs className="container-title-block">
            <MainBlock
              color={"#ffa800"}
              action={this.collapseBlockActive("order_information")}
              onChange={() =>
                this.handleChangecollapseBlock("order_information")
              }
            >
              Ordering information
            </MainBlock>
          </Divs>
          {this.collapseBlockActive("order_information") && (
            <Divs className="mt-3 mb-4">
              <>
                <div className="col-12 row" style={{ margin: 0 }}>
                  <Divs className="col-6" style={{ width: "50%" }}>
                    <div className="d-flex justify-content-between font-weight-bold mb-3">
                      <span>Delivery information</span>
                      <div
                        className="d-flex align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            shippingAdr_action_edit:
                              !this.state.shippingAdr_action_edit,
                          })
                        }
                      >
                        {shippingAdr_action_edit ? (
                          <GrClose title="Cancel" />
                        ) : (
                          <GrEdit title="Edit" />
                        )}
                      </div>
                    </div>
                    <ShippingAddressComponent
                      module_name={order.carrier.module_name}
                      shippingAdr_action_edit={shippingAdr_action_edit}
                      UlElements={UlElements}
                      shipping_address={order.shipping_address}
                      updateOrderAddress={this.updateOrderAddress}
                      customer={order.customer}
                    />
                  </Divs>
                  <Divs
                    className="col-6"
                    style={{
                      width: "50%",
                      borderLeft: "1px solid #e3e3e3",
                    }}
                  >
                    <div className="d-flex justify-content-between font-weight-bold mb-3">
                      <span>Payer information</span>
                      <div
                        className="d-flex align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            billingAdr_action_edit:
                              !this.state.billingAdr_action_edit,
                          })
                        }
                      >
                        {billingAdr_action_edit ? (
                          <GrClose title="Cancel" />
                        ) : (
                          <GrEdit title="Edit" />
                        )}
                      </div>
                    </div>
                    <BillingAddressComponent
                      disabled={disabled}
                      billingAdr_action_edit={billingAdr_action_edit}
                      UlElements={UlElements}
                      billing_address={order.billing_address}
                      postToRivile={this.props.postToRivile}
                      orderId={this.state.id}
                      onToggle={() =>
                        this.setState({
                          billingAdr_action_edit:
                            !this.state.billingAdr_action_edit,
                        })
                      }
                    />
                  </Divs>
                </div>
                <Divs className="mt-3 mb-2">
                  <OrderTotalComponent
                    total_price={order.total_price}
                    vat_code_pvm={order.is_without_vat}
                    total_discounts_tax_incl={order.total_discounts_tax_incl}
                    total_discounts={order.total_discounts}
                  />
                  <br />
                  {(order?.urgent ||
                    order?.status?.identifier == "finished") && (
                      <div
                        className={`d-flex justify-content-between align-items-center mb-3`}
                      >
                        {order?.urgent ? (
                          <>
                            <div className={"text-danger"}>
                              <AiOutlineInfoCircle
                                className="text-danger mr-2"
                                style={{ fontSize: 17 }}
                              />
                              Urgent order
                            </div>

                            <button
                              className="btn btn-sm btn-outline-danger d-flex justify-content-center align-items-center"
                              style={{
                                minWidth: "50px",
                                maxWidth: "150px",
                                height: "30px",
                              }}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  urgent: !order?.urgent,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-2">Cancel URGENT</span>
                            </button>
                          </>
                        ) : (
                          <>
                            <div />
                            <ClassicButtonOutline
                              loading={false}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  urgent: !order?.urgent,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-1">
                                {order?.urgent ? "Cancel" : "Set"} URGENT
                              </span>
                            </ClassicButtonOutline>
                          </>
                        )}
                      </div>
                    )}
                    <div
                        className={`d-flex justify-content-between align-items-center mb-3`}
                      >
                        {order?.vip ? (
                          <>
                            <div className={"text-danger"}>
                              <AiOutlineInfoCircle
                                className="text-danger mr-2"
                                style={{ fontSize: 17 }}
                              />
                              VIP order
                            </div>

                            <button
                              className="btn btn-sm btn-outline-danger d-flex justify-content-center align-items-center"
                              style={{
                                minWidth: "50px",
                                maxWidth: "150px",
                                height: "30px",
                              }}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  vip: !order?.vip,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-2">Cancel VIP</span>
                            </button>
                          </>
                        ) : (
                          <>
                            <div />
                            <ClassicButtonOutline
                              loading={false}
                              onClick={() =>
                                this.props.updateOrderAddress(this.state.id, {
                                  vip: !order?.vip,
                                })
                              }
                            >
                              <AiOutlineAlert size={16} />
                              <span className="ml-1">
                                {order?.vip ? "Cancel" : "Set"} VIP
                              </span>
                            </ClassicButtonOutline>
                          </>
                        )}
                    </div>
                  {(!!this.state.shipping_address_edit.comment ||
                    !!order.remark) && (
                      <div
                        className={`d-flex justify-content-start align-items-center text-danger`}
                      >
                        <AiOutlineInfoCircle
                          className="text-danger mr-2"
                          style={{ fontSize: 17 }}
                        />{" "}
                        Note from client :{" "}
                        {this.state.shipping_address_edit.comment || order.remark}
                      </div>
                    )}
                  {order?.duplicate_orders?.length > 0 && (
                    <div
                      className={`d-flex justify-content-start align-items-center text-danger`}
                    >
                      <AiOutlineInfoCircle
                        className="text-danger mr-2"
                        style={{ fontSize: 17 }}
                      />{" "}
                      Possible duplicate : the same customer has open order(s)
                      with identical products
                      {order.duplicate_orders.some(({ cod }) => cod)
                        ? " with COD"
                        : ""}{" "}
                      :{" "}
                      {order.duplicate_orders
                        .map(({ order_number }) => order_number)
                        .join(", ")}
                    </div>
                  )}
                </Divs>

                <MiniBlockOrderRows
                  editAction={!disabled}
                  color={"#ffcc69"}
                  action={this.collapseBlockActive("information_discounts")}
                  onChange={() =>
                    this.handleChangecollapseBlock("information_discounts")
                  }
                  goodsAddRow={this.collapseBlockActive(
                    "information_discounts_add"
                  )}
                  goodsAddRowClick={() =>
                    this.handleChangecollapseBlock("information_discounts_add")
                  }
                >
                  Discounts
                </MiniBlockOrderRows>
                {this.collapseBlockActive("information_discounts") && (
                  <OrderDiscounts
                    order_id={order.id}
                    order_cart_rules={order_cart_rules}
                    order_rows={order_rows}
                    disabled={disabled}
                    availableCreate={this.collapseBlockActive(
                      "information_discounts_add"
                    )}
                  />
                )}

                <OrderRowsTab
                  action={this.collapseBlockActive("information_goods")}
                  onAction={() =>
                    this.handleChangecollapseBlock("information_goods")
                  }
                  disabled={disabled}
                  order={order}
                  order_rows={order_rows}
                  shipping_address_email={
                    this.state.shipping_address_edit.other
                  }
                />

                {!disabled &&
                  order_rows.some((some) => some.required_serial_number) && (
                    <>
                      <MiniBlock
                        color={"#ffcc69"}
                        action={this.collapseBlockActive("serial_number")}
                        onChange={() =>
                          this.handleChangecollapseBlock("serial_number")
                        }
                      >
                        Serial numbers
                      </MiniBlock>
                      {this.collapseBlockActive("serial_number") && (
                        <Divs>
                          <div className="col-12 bg-silver">
                            <SerialNumberBlock
                              orderID={this.state.id}
                              updateSerialNumber={this.props.updateSerialNumber}
                              updateSerialNumberState={
                                this.props.updateSerialNumberState
                              }
                              options={order_rows.filter(
                                (filt) => filt.required_serial_number
                              )}
                            />
                          </div>
                        </Divs>
                      )}
                    </>
                  )}
                {!disabled && (
                  <>
                    <MiniBlock
                      color={"#ffcc69"}
                      action={this.collapseBlockActive("information_supply")}
                      onChange={() =>
                        this.handleChangecollapseBlock("information_supply")
                      }
                    >
                      Supply
                    </MiniBlock>
                    {this.collapseBlockActive("information_supply") && (
                      <Divs>
                        <SupplyComponent
                          order_rows={this.props.order_rows}
                          supplySupplier={this.props.supplySupplier}
                          orderId={this.state.id}
                          postOrderRow={postOrderRow}
                          order_shop_id={order.order_shop_id}
                        />
                      </Divs>
                    )}
                  </>
                )}
                <MiniBlock
                  color={"#ffcc69"}
                  action={this.collapseBlockActive("information_balances")}
                  onChange={() =>
                    this.handleChangecollapseBlock("information_balances")
                  }
                >
                  Residues
                </MiniBlock>
                {this.collapseBlockActive("information_balances") && (
                  <Divs>
                    <div className="col-12 bg-silver">
                      <OrderRowProductSuppliers order_id={order.id} />
                    </div>
                  </Divs>
                )}
                <MiniBlock
                  color={"#ffcc69"}
                  action={this.collapseBlockActive("information_status")}
                  onChange={() =>
                    this.handleChangecollapseBlock("information_status")
                  }
                >
                  Status
                </MiniBlock>
                {this.collapseBlockActive("information_status") && (
                  <Divs>
                    <StatusComponent
                      orderId={this.state.id}
                      avalaibleStatus={
                        disabled
                          ? []
                          : this.props.avalaibleStatus.filter(
                            (e) => (e.shop_id == order.order_shop_id || order.order_shop_id > 7 && e.shop_id == 1)
                          )
                      }
                      order_histories={order_histories}
                    />
                  </Divs>
                )}
                <React.Fragment>
                  <MiniBlockOrderRows
                    editAction={!disabled}
                    color={"#ffcc69"}
                    action={this.collapseBlockActive("information_delivery")}
                    onChange={() =>
                      this.handleChangecollapseBlock("information_delivery")
                    }
                    goodsAddRow={this.collapseBlockActive("delivery_add_col")}
                    goodsAddRowClick={() =>
                      this.handleChangecollapseBlock("delivery_add_col")
                    }
                  >
                    Delivery
                  </MiniBlockOrderRows>
                  {this.collapseBlockActive("information_delivery") && (
                    <Divs>
                      <DeliveryComponent
                        order_rows={order_rows}
                        delivery_add_col={this.collapseBlockActive(
                          "delivery_add_col"
                        )}
                        carrier={order.carrier}
                        orderId={order.id}
                        total_shipping={order.total_shipping_tax_incl}
                        org_total_shipping={order.org_total_shipping}
                        total_shipping_updated_by_name={order.total_shipping_updated_by_name}
                        total_shipping_confirmed_by_id={order.total_shipping_confirmed_by_id}
                        total_shipping_confirmed_by_name={order.total_shipping_confirmed_by_name}
                        payment={order.payment}
                        shipping_address={order.shipping_address}
                        updateShippingAddress={
                          this.updateShippingAddressTerminal
                        }
                        order_shop_id={order.order_shop_id}
                        cod={order.cod}
                      />
                    </Divs>
                  )}
                </React.Fragment>
                {!disabled && (
                  <React.Fragment>
                    <MiniBlockOrderRowsCustom
                      color={"#ffcc69"}
                      action={!!this.state.payments_col}
                      onChange={() => {
                        this.setState({
                          payments_col: this.state.payments_col
                            ? false
                            : "payments",
                        });
                      }}
                      goodsAddRow={this.collapseBlockActive("payments_add_col")}
                      goodsAddRowClick={() => this.paymentBlock()}
                    >
                      <span
                        className={
                          ["payments", true].includes(this.state.payments_col)
                            ? "text-primary text-decoration-underline  mr-2"
                            : "text-silver mr-2"
                        }
                        onClick={() =>
                          this.setState({
                            payments_col: "payments",
                          })
                        }
                      >
                        Payments
                      </span>{" "}
                      <span
                        className={
                          this.state.payments_col == "refunds"
                            ? "text-primary text-decoration-underline"
                            : "text-silver"
                        }
                        onClick={() =>
                          this.setState({
                            payments_col: "refunds",
                          })
                        }
                      >
                        <span>
                          Refunds{" "}
                          <Bubble up={true}>
                            {this.props.money_refund_items.length}
                          </Bubble>
                        </span>
                      </span>
                    </MiniBlockOrderRowsCustom>
                    {!!this.state.payments_col && (
                      <Divs>
                        <PaymentBlockComponent
                          payments_col={this.state.payments_col}
                          orderId={this.state.id}
                          order={order}
                          payments_add_col={this.collapseBlockActive(
                            "payments_add_col"
                          )}
                          total_price={order.total_price}
                          money_refund_items={this.props.money_refund_items}
                          paymentBlock={this.paymentBlock}
                          goodsAddRowClick={() =>
                            this.handleChangecollapseBlock("payments_add_col")
                          }
                        />
                      </Divs>
                    )}

                    {order?.id && (
                      <React.Fragment>
                        <MiniBlock
                          color={"#ffcc69"}
                          action={this.collapseBlockActive(
                            "information_actions_history"
                          )}
                          onChange={() =>
                            this.handleChangecollapseBlock(
                              "information_actions_history"
                            )
                          }
                        >
                          Actions history
                        </MiniBlock>
                        {this.collapseBlockActive(
                          "information_actions_history"
                        ) && (
                            <Divs>
                              <ActionHistoryContent order_id={order.id} />
                            </Divs>
                          )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </>
            </Divs>
          )}
          {!disabled && (
            <>
              <MainBlock
                color={"#BD00FF"}
                action={this.collapseBlockActive("information_leasing")}
                onChange={() =>
                  this.handleChangecollapseBlock("information_leasing")
                }
              >
                Leasing
              </MainBlock>
              {this.collapseBlockActive("information_leasing") && (
                <Divs className="bg-silver mb-4">
                  <LeasingComponent
                    orderId={this.state.id}
                    p_leasing_number={this.props.order.leasing_number}
                    p_leasing_discount={this.props.order.leasing_discount}
                    p_leasing_advance={this.props.order.leasing_advance}
                    p_leasing_cod={this.props.order.leasing_cod}
                    p_leasing_term={this.props.order.leasing_term}
                    p_order_total={this.props.order.total_price}
                    paymentTitle={this.props.order.payment}
                    leasing_discount_used={
                      this.props.order.leasing_discount_used
                    }
                  />
                </Divs>
              )}
            </>
          )}

          <Divs className="bg-silver">
            <MainBlock
              color={"#008aff"}
              action={this.collapseBlockActive("comment_col")}
              onChange={() => this.handleChangecollapseBlock("comment_col")}
            >
              Comments
            </MainBlock>
            {this.collapseBlockActive("comment_col") && (
              <div className="mb-4 mt-2">
                <MiniBlock
                  color={"#7ebff7"}
                  action={this.collapseBlockActive("ka_comment_col")}
                  onChange={() =>
                    this.handleChangecollapseBlock("ka_comment_col")
                  }
                >
                  KA comments
                </MiniBlock>
                {this.collapseBlockActive("ka_comment_col") && (
                  <div className="col-12">
                    <SubmitComment
                      orderId={this.state.id}
                      type="comment_ka"
                      options={(this.props.comments_state || []).filter(e => e.name?.toLowerCase() !== "cancelled")}
                    />
                    <PreviewComment
                      comments={order.comments}
                      type="comment_ka"
                    />
                  </div>
                )}
                {!disabled && (
                  <>
                    <MiniBlock
                      color={"#7ebff7"}
                      action={this.collapseBlockActive("manag_comment_col")}
                      onChange={() =>
                        this.handleChangecollapseBlock("manag_comment_col")
                      }
                    >
                      Management comments
                    </MiniBlock>
                    {this.collapseBlockActive("manag_comment_col") && (
                      <div className="col-12">
                        <SubmitComment
                          orderId={this.state.id}
                          type="comment_management"
                          options={this.props.comments_state || []}
                          order_rows={this.props.order_rows}
                        />
                        <PreviewComment
                          comments={order.comments}
                          type="comment_management"
                        />
                      </div>
                    )}
                  </>
                )}
                <MiniBlock
                  color={"#7ebff7"}
                  action={this.collapseBlockActive("log_comment_col")}
                  onChange={() =>
                    this.handleChangecollapseBlock("log_comment_col")
                  }
                >
                  Logistic comments
                </MiniBlock>
                {this.collapseBlockActive("log_comment_col") && (
                  <div className="col-12">
                    <SubmitComment
                      orderId={this.state.id}
                      type="comment_logistic"
                      options={this.props.comments_state || []}
                    />
                    <PreviewComment
                      comments={order.comments}
                      type="comment_logistic"
                    />
                  </div>
                )}
                {/* TODO */}
                {true && (
                  <>
                    <MiniBlock
                      color={"#7ebff7"}
                      action={this.collapseBlockActive(
                        "tch_pickup_comment_col"
                      )}
                      onChange={() =>
                        this.handleChangecollapseBlock("tch_pickup_comment_col")
                      }
                    >
                      Parduotuvės komentarai
                    </MiniBlock>
                    {this.collapseBlockActive("tch_pickup_comment_col") && (
                      <div className="col-12">
                        <SubmitComment
                          orderId={this.state.id}
                          type="comment_tch_pickup"
                          options={this.props.comments_state || []}
                        />
                        <PreviewComment
                          comments={order.comments}
                          type="comment_tch_pickup"
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </Divs>

          <Divs>
            <MainBlock
              color={"#00aaa0"}
              action={this.collapseBlockActive("AttachDocuments")}
              onChange={() => this.handleChangecollapseBlock("AttachDocuments")}
            >
              Uploading documents
            </MainBlock>
            {this.collapseBlockActive("AttachDocuments") && (
              <AttachOrderDocument
                disabled={disabled}
                order_documents={order_documents}
                orderId={order.id}
              />
            )}
          </Divs>
          {!!order.id && !disabled && (
            <Divs>
              <MainBlock
                color={"#0443EF"}
                action={this.collapseBlockActive("tax_free_col")}
                onChange={() => this.handleChangecollapseBlock("tax_free_col")}
              >
                Tax free
              </MainBlock>
              {this.collapseBlockActive("tax_free_col") && (
                <OrderTaxFree
                  order_id={order.id}
                  order_rows={this.props.order_rows}
                />
              )}
            </Divs>
          )}
        </div>
        <div className="col-6">
          {!disabled && (
            <>
              <Divs>
                <MainBlock
                  color={"#c600ff"}
                  action={this.collapseBlockActive("AdditionalServices")}
                  onChange={() =>
                    this.handleChangecollapseBlock("AdditionalServices")
                  }
                >
                  Documents
                </MainBlock>
                {this.collapseBlockActive("AdditionalServices") && (
                  <div className="bg-silver mb-4">
                    <AdditionalServicesMain
                      contracts={contracts}
                      orderId={order.id}
                      orderId2={order.id_order}
                      documentTypeArray={documentType}
                      order_rows={order_rows}
                      addContract={this.props.addContract}
                      updateContract={this.props.updateContract}
                      deleteContractItem={this.props.deleteContractItem}
                      deleteContract={this.props.deleteContract}
                      billing_address={this.props.order.billing_address}
                      sendContractEmail={this.props.sendContractEmail}
                      firstAddContract={this.props.firstAddContract}
                      firstDeleteContract={this.props.firstDeleteContract}
                      changeContractItems={this.props.changeContractItems}
                      errors={this.props.errors}
                    />
                  </div>
                )}
              </Divs>
            </>
          )}
          <Divs>
            <MainBlock
              color={"#00aaa0"}
              custom={this.collapseBlockActive("order_shipment_information")}
              action={this.collapseBlockActive("order_shipment_information")}
              onChange={() =>
                this.handleChangecollapseBlock("order_shipment_information")
              }
            >
              <div className="d-flex align-items-center justify-content-between">
                <div
                  className="w-50"
                  onClick={() =>
                    this.handleChangecollapseBlock("order_shipment_information")
                  }
                >
                  Shipping
                </div>
                {this.collapseBlockActive("order_shipment_information") &&
                  !disabled && (
                    <SelectForm
                      options={shipment_types_options.filter(
                        option => !["matkahuolto", "posti"].includes(option.value)
                      )}
                      selector="order_type"
                      value={this.state.order_type}
                      onChange={(e) =>
                        this.setState({
                          ...handleChangeOrdertypeGlobal(
                            e,
                            this.state.order_type,
                            {
                              ...this.props.order.shipping_address,
                              comment: this.state.shipping_address_edit.comment,
                            },
                            {
                              ...this.props.order.billing_address,
                              comment: this.state.shipping_address_edit.comment,
                            },
                            this.state.cod,
                            order.carrier
                          ),
                        })
                      }
                    />
                  )}
              </div>
            </MainBlock>
            {this.collapseBlockActive("order_shipment_information") && (
              <div>
                <ShippingComponent
                  shop_identifier={order.order_shop?.identifier}
                  disabled={disabled || this.props.modal_type == "TrRequest"}
                  order_type={order_type}
                  record_id={order.id}
                  order={order}
                  delivery={this.state.delivery}
                  user={this.props.auth.user}
                  shipping_address_edit={this.state.shipping_address_edit}
                  terminalSelected={this.state.terminalSelected}
                  handleChangeText={this.handleChangeText}
                  order_rows={order_rows_rebuild}
                  shipments={shipments}
                  deleted_shipments={this.props.deleted_shipments}
                  onChangeCheckBoxDelivery={(e) =>
                    this.setState(
                      onChangeCheckBoxDeliveryGlobal(e, this.state.delivery, this.state.terminalSelected, this.state.savedTerminalSelected)
                    )
                  }
                  createShipping={this.createShipping}
                  errors={this.props.errors}
                  variables={{
                    suppliers: this.state.suppliers,
                    weight: this.state.weight,
                    pack: this.state.pack,
                    carrying: this.state.carrying,
                    recycle: this.state.recycle,
                    connect: this.state.connect,
                    cod: this.state.cod,
                    order_return: this.state.order_return,
                    sendingDocuments: this.state.sendingDocuments,
                    deliveryTime: this.state.deliveryTime,
                    delivery_after_18: this.state.delivery_after_18,
                    deliveryOnSaturday: this.state.deliveryOnSaturday,
                    delivery_same_day: this.state.delivery_same_day,
                    cod_amount: this.state.cod_amount,
                    who: this.state.who,
                    deliveryTimeHours: this.state.deliveryTimeHours,
                    swap: this.state.swap,
                    lp_express_sizes: this.state.lp_express_sizes,
                    shipping_loading: this.state.shipping_loading,
                    ignore_stock_check: this.state.ignore_stock_check,
                  }}
                  skip_labels={this.state.skip_labels}
                  setSkipLabels={this.setSkipLabels}
                  selectedCarrier={this.state.selectedCarrier}
                  onChangeCarrier={this.onChangeCarrier}
                />
              </div>
            )}
          </Divs>
          <Divs>
            <MainBlock
              color={"#adcb35"}
              action={this.collapseBlockActive("SmsSending")}
              onChange={() => this.handleChangecollapseBlock("SmsSending")}
            >
              Send SMS to number{" "}
              {
                <span
                  className={
                    phonenumberValid(order.billing_address.phone)
                      ? ""
                      : "text-danger"
                  }
                >
                  {order.billing_address.phone}
                </span>
              }
            </MainBlock>
            {this.collapseBlockActive("SmsSending") && (
              <SmsSending
                shop_identifier={order.order_shop?.identifier}
                id={this.state.id}
                phoneNumber={order.billing_address.phone}
                shipments={this.props.shipments}
                country_id={this.state.shipping_address_edit.country_id}
              />
            )}
          </Divs>
          {!disabled && !!order.id && (
            <Divs>
              <MainBlock
                color={"#008AFF"}
                action={this.collapseBlockActive("order_history")}
                onChange={() => this.handleChangecollapseBlock("order_history")}
              >
                Actions history
              </MainBlock>
              {this.collapseBlockActive("order_history") && (
                <OrderActivities order_id={order.id} />
              )}
            </Divs>
          )}
          {!disabled && !!order.id && (
            <Divs>
              <MainBlock
                color={"#00aaa0"}
                action={this.collapseBlockActive("order_history_table")}
                onChange={() => {
                  const shouldOpen = !this.collapseBlockActive("order_history_table");
                  this.handleChangecollapseBlock("order_history_table");

                  if (shouldOpen && this.shouldLoadCustomerOrders()) {
                    this.fetchCustomerOrders();
                  }
                }}
              >
                Order History
              </MainBlock>
              {this.collapseBlockActive("order_history_table") && (
                <div className="pt-3 bg-silver">
                  <Table
                    loading={this.state.orderHistoryTableLoading}
                    rowClassName={() => "bg-silver"}
                    size="small"
                    columns={[
                      {
                        title: "Order No.",
                        dataIndex: "order_no",
                        render: (v, record) => (
                          <span
                            className="text-xs text-primary cursor-pointer"
                            style={{ textDecoration: "underline" }}
                            onClick={() => this.openOrderFromHistory(record.id)}
                          >
                            {v}
                          </span>
                        ),
                      },
                      { title: "Date", dataIndex: "date", render: (v) => <span className="text-xs">{v}</span> },
                      {
                        title: "Goods",
                        dataIndex: "goods",
                        render: (v) => (
                          <span className="text-xs" style={{ whiteSpace: "pre-line" }}>
                            {v}
                          </span>
                        ),
                      },
                      { title: "Status", dataIndex: "status", render: (v) => <span className="text-xs">{v}</span> },
                      { title: "Sum", dataIndex: "sum", render: (v) => <span className="text-xs">{v}</span> },
                    ]}
                    dataSource={this.state.orderHistoryTableData}
                    pagination={false}
                  />
                </div>
              )}
            </Divs>
          )}
        </div>
      </div>
    );
  }
}

const OrderRowsTab = ({
  action,
  onAction,
  disabled,
  order,
  order_rows,
  shipping_address_email,
}) => {
  const [recordType, setRecordType] = useState("order_rows");
  console.log({ order });
  return (
    <React.Fragment>
      <MiniBlockOrderRowsCustom
        editAction={!disabled && recordType.includes("order_rows")}
        color={"#ffcc69"}
        action={action}
        onChange={() => onAction()}
        goodsAddRow={recordType == "order_rows_create"}
        goodsAddRowClick={() =>
          setRecordType((prev) =>
            prev == "order_rows" ? "order_rows_create" : "order_rows"
          )
        }
      >
        <span
          className={
            ["order_rows", "order_rows_create"].includes(recordType)
              ? "text-primary text-decoration-underline  mr-2"
              : "text-silver mr-2"
          }
          onClick={() => {
            setRecordType("order_rows");
            if (!action) {
              onAction();
            }
          }}
        >
          Goods
        </span>{" "}
        <span
          className={
            recordType == "returns"
              ? "text-primary text-decoration-underline"
              : "text-silver"
          }
          onClick={() => {
            setRecordType("returns");
            if (!action) {
              onAction();
            }
          }}
        >
          <span>Returns </span>
        </span>
      </MiniBlockOrderRowsCustom>
      {action && (
        <div className="bg-silver">
          {recordType.includes("order_rows") ? (
            <OrderRowsComponent
              disabled={disabled}
              order_rows={order_rows}
              order_id={order.id}
              order_shop={order.order_shop}
              information_goods_add={recordType == "order_rows_create"}
              shipping_address_email={shipping_address_email}
            />
          ) : (
            <OrderRowsReturn
              order_rows={order_rows}
              order_shop={order.order_shop}
              order_id={order.id}
              total_shipping_tax_incl={order.total_shipping_tax_incl}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

const UlElements = styled.ul`
  margin: 0;
  list-style-type: none;
  padding: 0 1px;
  li {
    font-size: 15px;
    color: #000000;
    margin-bottom: 5px;
    word-wrap: break-word;
  }
`;

const Divs = styled.div`
  display: block;
  color: #000000;
  font-size: 15px;
  font-weight: 400;
  & .text-bold {
    font-size: 14px;
    line-height: 20px;
    color: #030303;
    font-weight: 600;
  }
  & .residuesItem {
    font-size: 0.8rem;
    word-wrap: break-word;
  }

  & .orange_color {
    color: #f7951e;
  }
  & .addDoc {
    margin-top: 5px;
    color: #f7951e;
    &:hover {
      color: #bd6903;
      border-bottom: 1px solid #f7951e;
      cursor: pointer;
    }
  }
  & .input_text {
    right: 7%;
    top: 50%;
    font-weight: bold;
    text-transform: uppercase;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
`;

const mapStateToProps = (state) => ({
  auth: state.auth,
  documentType: state.documentType.documentType,
  // suppliersItems: state.supplier.suppliers,
  errors: state.errors,
  // ShowIdData
  order_histories: state.orders.order_histories,
  contracts: state.orders.contracts,
  order_rows: state.orders.order_rows,
  payments: state.orders.payments,
  shipments: state.orders.shipments,
  deleted_shipments: state.orders.deleted_shipments,
  money_refund_items: state.orders.money_refund_items,
  order_documents: state.orders.order_documents,
  order: state.orders.order,
  loading_order: state.orders.loading_order,
  or_quantity_manual: state.orders.or_quantity_manual,
  pickup_addresses: state.options.pickup_addresses,
  ordersShipmentsOver80Kg: state.orders.ordersShipmentsOver80Kg,
});
export default connect(mapStateToProps, {
  getOrder,
  getDocumentType,
  addContract,
  updateContract,
  deleteContractItem,
  deleteContract,
  sendContractEmail,
  createOrderStatus,
  firstAddContract,
  firstDeleteContract,
  changeContractItems,
  updateSerialNumber,
  updateSerialNumberState,
  postToRivile,
  clearErrors,
  postOrderShipping,
  updateOrderAddress,
  editPayment,
  setCountriesOptions,
  setParcelTerminalsOptions,
})(OrderShowModal);
